import { render, staticRenderFns } from "./ContactHero.vue?vue&type=template&id=36e2c8ea&scoped=true&"
import script from "./ContactHero.vue?vue&type=script&lang=js&"
export * from "./ContactHero.vue?vue&type=script&lang=js&"
import style0 from "./ContactHero.vue?vue&type=style&index=0&id=36e2c8ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e2c8ea",
  null
  
)

export default component.exports